
import { ref, get } from 'firebase/database';
import { database } from '../firebase/config';

export class PubDevClient {
  constructor() {
    this.cache = new Map();
    this.ongoingRequests = new Map();
    this.CACHE_DURATION = 5 * 60 * 1000;
  }

  async getPackageStats(packageName = 'geolocator') {
    const cacheKey = packageName;
    
    const cached = this.cache.get(cacheKey);
    if (cached && (Date.now() - cached.timestamp) < this.CACHE_DURATION) {
      return cached.data;
    }

    if (this.ongoingRequests.has(cacheKey)) {
      return await this.ongoingRequests.get(cacheKey);
    }

    const requestPromise = (async () => {
      try {
        const statsRef = ref(database, '/stats/packageStats');
        const snapshot = await get(statsRef);

        if (snapshot.exists()) {
          const stats = snapshot.val();
          const formattedStats = {
            weeklyDownloads: stats.weeklyDownloads,
            totalDownloads: stats.totalDownloads,
            likes: stats.likes,
            pubPoints: stats.pubPoints,
            popularity: stats.popularity
          };
          
          this.cache.set(cacheKey, {
            data: formattedStats,
            timestamp: Date.now()
          });
          
          return formattedStats;
        } else {
          throw new Error('Package stats not found in database');
        }
      } catch (error) {
        console.error('Error fetching package stats:', error);
        return {
          weeklyDownloads: '10.762',
          totalDownloads: '20.547',
          likes: '1.200',
          pubPoints: 130,
          popularity: 95
        };
      } finally {
        this.ongoingRequests.delete(cacheKey);
      }
    })();

    this.ongoingRequests.set(cacheKey, requestPromise);
    
    return await requestPromise;
  }

  async getGeolocatorStats() {
    return this.getPackageStats('geolocator');
  }

  clearCache() {
    this.cache.clear();
    this.ongoingRequests.clear();
  }
}

const pubDevClient = new PubDevClient();
export default pubDevClient;